export { PlpProductGrid } from "./PlpProductGrid";
export type { PlpProductGridProps } from "./PlpProductGrid";
